import { PlayerClassType } from "../enum/PlayerClassType";
import Vector2 from "../math/Vector2";
import Player from "./Player";
import Gun from "./Gun";
import Ability from "./Ability";
import GameManager from "./GameManager";
import { KeyCode } from "../lib/Input";

export default class PlayerClass {

    type: PlayerClassType;
    player: Player;
    primaryWeapon: Gun;
    secondaryWeapon: Gun;
    abilities: Ability[] = [];

    get ctx() {return this.player.ctx;}

    constructor(type: PlayerClassType, player: Player, weap1: Gun, weap2: Gun) {
        this.type = type;
        this.player = player;
        this.primaryWeapon = weap1;
        this.secondaryWeapon = weap2;
    }

    Update() {
        this.abilities.forEach(ability => ability.Update());
        this.primaryWeapon.Update();
        this.secondaryWeapon.Update();
    }

    LateUpdate() {}

    Draw(color: string) {
        if (this.player.isOwner) {
            this.primaryWeapon.Draw(4);
            this.secondaryWeapon.Draw(10);

            this.abilities.forEach(ability => ability.Draw());
        }
        
        
    }

    DrawAbilityOverlay() {
        const windowLocation = new Vector2(64, 64);
        const drawpos = windowLocation.add(Vector2.one.scale(22));
        const ctx = this.player.ctx;
        const engine = this.player.engine;
        this.ctx.fillStyle = '#55ff55';
        this.ctx.fillRect(windowLocation.x-2, windowLocation.y-2, 270, 260);
        this.ctx.fillStyle = engine.viewport.bgColor;
        this.ctx.fillRect(windowLocation.x, windowLocation.y, 266, 256);

        this.ctx.fillStyle = '#55ff55';
        for (const ability of this.abilities) {
            engine.FillRectScreenFromCenter(drawpos, new Vector2(34, 34));
            GameManager.Singleton?.DrawAbilityIcon(ability.icon, drawpos);
            engine.drawTexts([`${ability.energyCost}`], drawpos.add(Vector2.one.scale(16)), {align: 'end', baseline: 'bottom', color: "white"});
            ctx.textAlign = 'left';
            ctx.textBaseline = 'middle';
            ctx.fillText(ability.trigger.substring(5), drawpos.x + 26, drawpos.y);

            engine.drawTextWrap(ability.info || "N/A", drawpos.add(new Vector2(52, -16)), 190);

            drawpos.y += 70;
        }
    }
}